import { render } from "./ColorList.vue?vue&type=template&id=45f924bc&scoped=true"
import script from "./ColorList.vue?vue&type=script&lang=js"
export * from "./ColorList.vue?vue&type=script&lang=js"

import "./ColorList.vue?vue&type=style&index=0&id=45f924bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45f924bc"

export default script